import React, { RefCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default function useMeasure(
  property: keyof HTMLElement = 'scrollHeight'
): [{ ref: RefCallback<any> }, number] {
  const [ref, setRef] = React.useState<HTMLElement>();
  const [height, set] = React.useState<any>(0);

  React.useLayoutEffect(() => {
    let animationFrameID: number;
    const ro = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
      animationFrameID = window.requestAnimationFrame(() =>
        set((entry.target as HTMLElement)[property])
      );
    });

    ref && ro.observe(ref);

    return () => {
      window.cancelAnimationFrame(animationFrameID);
      ro.disconnect();
    };
  }, [property, ref]);

  return [{ ref: (node) => setRef(node) }, height];
}
